export const environment = {
  production: true,
   baseurl: '/epatrimonioapi',
   baseAuthUrl: '/sgatiapi/',
};
